import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LiffService } from '../../../core/services/liff.service';

@Component({
  selector: 'app-liff-loader',
  imports: [],
  templateUrl: './liff-loader.component.html',
  styleUrl: './liff-loader.component.css',
})
export class LiffLoaderComponent implements OnInit {
  constructor(
    private liffService: LiffService,
    private cookieService: CookieService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit() {
    localStorage.removeItem('login_status');
    localStorage.removeItem('token_user');
    this.cookieService.delete('login_status');
    this.cookieService.delete('token_user');

    try {
      await this.liffService.initLiff();
    } catch (err) {
      console.error('LIFF init failed on loader:', err);
      return;
    }

    const redirectPath =
      this.route.snapshot.queryParamMap.get('redirect') || '/home';

    const ref = this.route.snapshot.queryParamMap.get('ref');
    if (ref) {
      localStorage.setItem('ref_code', ref);
      this.cookieService.set('ref_code', ref);
    }

    const res = await this.liffService.completeAuthAfterLiff();
    if (res?.success && res.registered) {
      const name =
        this.cookieService.get('display_name') ||
        localStorage.getItem('display_name') ||
        '';

      this.router.navigate([redirectPath]);
      this.liffService.updateName(name).catch((err) => {
        console.error('updateName failed:', err);
      });
      return;
    }

    if (res?.success && !res.registered) {
      this.router.navigate(['/register-form'], {
        queryParams: { redirect: redirectPath },
      });
      return;
    }

    // ไม่มี session ที่ใช้ได้ — ค้างที่ /register (อย่าเด้ง home / register-form)
    console.error('Auth failed after LIFF — stay on register', res);
  }
}
